<template>
  <!-- 定制化行业解决方案 -->
  <div class="programme-index">
    <div class="container">
      <div class="cell">
        <h3 class="wow fadeInUp title" data-wow-delay="50ms">
          定制化行业解决方案
        </h3>
        <h5 class="wow fadeInUp des" data-wow-delay="150ms">
          针对行业特点及各类场景深度定制，引领业务升级
        </h5>
      </div>
      <div class="tab-boxs wow fadeInUp" data-wow-delay="100ms">
        <div class="userSo">
          <div class="userSs">
            <div class="swiper-wrapper" id="swiperDiv">
              <!-- 一 -->
              <div @click="selectBar(0)" :class="['swiper-slide', actIndex === 0 ? 'slide-active' : '']">
                <div class="inner">
                  <img src="@/assets/images/indexSolution-icon1.png" alt="" />
                  <p>电子商务</p>
                </div>
              </div>
              <!-- 二 -->
              <div @click="selectBar(1)" :class="['swiper-slide', actIndex === 1 ? 'slide-active' : '']">
                <div class="inner">
                  <img src="@/assets/images/indexSolution-icon2.png" alt="" />
                  <p>人力资源</p>
                </div>
              </div>
              <!-- 三 -->
              <div @click="selectBar(2)" :class="['swiper-slide', actIndex === 2 ? 'slide-active' : '']">
                <div class="inner">
                  <img src="@/assets/images/indexSolution-icon3.png" alt="" />
                  <p>汽车服务</p>
                </div>
              </div>
              <!-- 四 -->
              <div @click="selectBar(3)" :class="['swiper-slide', actIndex === 3 ? 'slide-active' : '']">
                <div class="inner">
                  <img src="@/assets/images/indexSolution-icon4.png" alt="" />
                  <p>房地产</p>
                </div>
              </div>
              <!-- 五 -->
              <div @click="selectBar(4)" :class="['swiper-slide', actIndex === 4 ? 'slide-active' : '']">
                <div class="inner">
                  <img src="@/assets/images/indexSolution-icon5.png" alt="" />
                  <p>数字政府</p>
                </div>
              </div>
              <!-- 六 -->
              <div @click="selectBar(5)" :class="['swiper-slide', actIndex === 5 ? 'slide-active' : '']">
                <div class="inner">
                  <img src="@/assets/images/indexSolution-icon6.png" alt="" />
                  <p>房屋租赁</p>
                </div>
              </div>
              <!-- 七 -->
              <div @click="selectBar(6)" :class="['swiper-slide', actIndex === 6 ? 'slide-active' : '']">
                <div class="inner">
                  <img src="@/assets/images/indexSolution-icon7.png" alt="" />
                  <p>智慧旅游</p>
                </div>
              </div>
              <!-- 八 -->
              <div @click="selectBar(7)" :class="['swiper-slide', actIndex === 7 ? 'slide-active' : '']">
                <div class="inner">
                  <img src="@/assets/images/indexSolution-icon8.png" alt="" />
                  <p>教育培训</p>
                </div>
              </div>
              <!-- 九 -->
              <div @click="selectBar(8)" :class="['swiper-slide', actIndex === 8 ? 'slide-active' : '']">
                <div class="inner">
                  <img src="@/assets/images/indexSolution-icon9.png" alt="" />
                  <p>制造业</p>
                </div>
              </div>
              <!-- 十 -->
              <div @click="selectBar(9)" :class="['swiper-slide', actIndex === 9 ? 'slide-active' : '']">
                <div class="inner">
                  <img src="@/assets/images/indexSolution-icon10.png" alt="" />
                  <p>零售快消</p>
                </div>
              </div>
              <!-- 十一 -->
              <div @click="selectBar(10)" :class="['swiper-slide', actIndex === 10 ? 'slide-active' : '']">
                <div class="inner">
                  <img src="@/assets/images/indexSolution-icon11.png" alt="" />
                  <p>物流运输</p>
                </div>
              </div>
              <!-- 十二 -->
              <!--<div
						@click="clicks(11)"
							class="swiper-slide">
							<div class="inner">
								<img src="${prefix('images/indexSolution-icon12.png')}" alt="">
								<p>互联网金融</p>
							</div>
						</div>-->
              <!-- <div class="line"></div> -->
            </div>
          </div>
          <div class="userPrevo" v-show="showPre">
            <div class="userBtn userPrev">
              <img src="@/assets/images/black-rightArrow.png" alt="" />
            </div>
          </div>
          <div class="userNexto" v-show="showNext">
            <div class="userBtn userNext">
              <img src="@/assets/images/black-rightArrow.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div id="dzhfaActive" class="wow fadeIn prog_list" data-wow-delay="150ms">
        <!-- 1 -->
        <div :class="['every', 'item', actIndex === 0 ? 'active' : '']">
          <div class="content-box">
            <div class="left">
              <img src="@/assets/images/chain-bigImg.png" alt="" />
            </div>
            <div class="right">
              <div class="righti">
                <h6 class="name">电商平台电子签名解决方案</h6>
                <p class="content">
                  随着互联网的高速发展，电商已经成为日常生活中不可分割的一部分，近年来垂直电商、跨境电商、社交电商等细分领域不断兴起，电商行业呈现出百花齐放的繁荣景象，同时也对电商平台提出了更高的要求，而e签宝则针对电商平台提供了一整套成熟的解决方案。
                </p>
                <a href="https://www.esign.cn/pcgw/jjfa/dzsw/" class="get-info" target="_blank">了解详情</a>
                <div class="name demo">客户案例</div>
                <div class="demo-list">
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/alibaba-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/taobao-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/suning-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/vip-icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 2 -->
        <div :class="['every', 'item', actIndex === 1 ? 'active' : '']">
          <div class="content-box">
            <div class="left">
              <img src="@/assets/images/esign-chain.png" alt="" />
            </div>
            <div class="right">
              <div class="righti">
                <h6 class="name">人力资源解决方案</h6>
                <p class="content">
                  伴随着行业的快速增长，在企业提供人力资源服务的过程中，产生了大量合同签署的需求，越来越多的企业开始引入更高效的签约方式，提升业务开展效率、降低业务开展成本，并解决服务过程中合约缔造的问题。
                </p>
                <a href="https://www.esign.cn/pcgw/jjfa/rlzy/" class="get-info" target="_blank">了解详情</a>
                <div class="name demo">客户案例</div>
                <div class="demo-list">
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/lagou-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/51job-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/doumi-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/qianhui-icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 3 -->
        <div :class="['every', 'item', actIndex === 2 ? 'active' : '']">
          <div class="content-box">
            <div class="left">
              <img src="@/assets/images/carService-chain.png" alt="" />
            </div>
            <div class="right">
              <div class="righti">
                <h6 class="name">汽车服务平台解决方案</h6>
                <p class="content">
                  互联网在改变各行各业，出现了越来越多的互联网汽车服务平台，围绕着汽车后市场提供的服务内容，服务过程中迫切需要通过线上签订合同，
                  实现全流程不见面的网上交易。
                </p>
                <a href="https://www.esign.cn/pcgw/jjfa/qcfw/" class="get-info" target="_blank">了解详情</a>
                <div class="name demo">客户案例</div>
                <div class="demo-list">
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/renrenCar-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/guazi-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/geely-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/yutong-icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 4 -->
        <div :class="['every', 'item', actIndex === 3 ? 'active' : '']">
          <div class="content-box">
            <div class="left">
              <img src="@/assets/images/estate-chain.png" alt="" />
            </div>
            <div class="right">
              <div class="righti">
                <h6 class="name">地产行业解决方案</h6>
                <p class="content">
                  随着行业进入成熟期，逐渐形成集聚效应，强者恒强，而市场的成熟期也意味着进入了一定的瓶颈期，如何通过信息化手段达到降本增效，是很多房地产公司需要考虑的问题，而电子合同是重要的方式之一。
                </p>
                <a href="https://www.esign.cn/pcgw/jjfa/fdc/" class="get-info" target="_blank">了解详情</a>
                <div class="name demo">客户案例</div>
                <div class="demo-list">
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/lvcheng-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/yinchegn-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/hongxing-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/zhengda-icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 5 -->
        <div :class="['every', 'item', actIndex === 4 ? 'active' : '']">
          <div class="content-box">
            <div class="left">
              <img src="@/assets/images/affairs-chain.png" alt="" />
            </div>
            <div class="right">
              <div class="righti">
                <h6 class="name">政务服务电子签章解决方案</h6>
                <p class="content">
                  党的十八大以来，国家层面相继出台了一系列文件，旨在通过信息化手段解决网上政务服务不便捷、平台不互通、数据不共享、线上线下联通不畅、标准化规范化程度不高等问题，实现政务服务平台化、协同化、标准化、精准化和便捷化，这样的需求下肯定少不了e签宝电子签章的帮助。
                </p>
                <a href="https://www.esign.cn/pcgw/jjfa/szzf/" class="get-info" target="_blank">了解详情</a>
                <div class="name demo">客户案例</div>
                <div class="demo-list">
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/goverment-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/ningbo-government.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/service-center.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/cma-cov.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 6 -->
        <div :class="['every', 'item', actIndex === 5 ? 'active' : '']">
          <div class="content-box">
            <div class="left">
              <img src="@/assets/images/house-platform.png" alt="" />
            </div>
            <div class="right">
              <div class="righti">
                <h6 class="name">租房平台电子签名解决方案</h6>
                <p class="content">
                  随着国家租房行业政策的利好，大量地产及互联网企业开始涉水长租公寓市场，纷纷设立互联网租房平台，在线平台需要在提升客户体验的同时，保障租房合同的法律效力，e签宝针对此需求提供专业的解决方案。
                </p>
                <a href="https://www.esign.cn/pcgw/jjfa/fwzl/" class="get-info" target="_blank">了解详情</a>
                <div class="name demo">客户案例</div>
                <div class="demo-list">
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/beike-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/haoshihuabang-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/mogu-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/Q-fang.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 7 -->
        <div :class="['every', 'item', actIndex === 6 ? 'active' : '']">
          <div class="content-box">
            <div class="left">
              <img src="@/assets/images/tourism-chain.png" alt="" />
            </div>
            <div class="right">
              <div class="righti">
                <h6 class="name">旅游平台电子签名解决方案</h6>
                <p class="content">
                  近几年互联网旅游平台快速发展，旅游行业逐步完成线上化，在提供便捷的同时也需要通过签署合同来保证游客的权益，所以旅行社和游客之间通过在线的服务平台便捷达成契约关系的同时，可以通过e签宝签订一份“方便且安全”的旅游电子合同，提供完善的法律保障。
                </p>
                <a href="https://www.esign.cn/pcgw/jjfa/zhly/" class="get-info" target="_blank">了解详情</a>
                <div class="name demo">客户案例</div>
                <div class="demo-list">
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/tuniu-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/tongcheng-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/fengtu-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/xiecheng-icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 8 -->
        <div :class="['every', 'item', actIndex === 7 ? 'active' : '']">
          <div class="content-box">
            <div class="left">
              <img src="@/assets/images/education-chain.png" alt="" />
            </div>
            <div class="right">
              <div class="righti">
                <h6 class="name">教育平台电子签名解决方案</h6>
                <p class="content">
                  近年来在线学习的方式已逐渐渗透于人们的日常生活，未来几年，在线教育技术的持续升级，在线学习产品的丰富和成熟都将推动在线教育市场规模进一步增长，在教育市场蓬勃发展的情况下，可以通过电子签章的使用可以解决在线课程购买，在线学历相关证明开具等问题。
                </p>
                <a href="https://www.esign.cn/pcgw/jjfa/jypx/" class="get-info" target="_blank">了解详情</a>
                <div class="name demo">客户案例</div>
                <div class="demo-list">
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/haoweilai-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/xueersi-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/gaodun-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/yixuetang-icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 9 -->
        <div :class="['every', 'item', actIndex === 8 ? 'active' : '']">
          <div class="content-box">
            <div class="left">
              <img src="@/assets/images/manufacturing-chain.png" alt="" />
            </div>
            <div class="right">
              <div class="righti">
                <h6 class="name">制造业电子签章解决方案</h6>
                <p class="content">
                  制造业公司已经形成了一定规模，大都是集团型公司，通常有众多分支机构且分布广泛，这类企业由于业务需求会面临向各分支机构授权制定和使用印章，并且所涉及到的场景非常多，如何从原有线下模式转型线上化的方式，e签宝提供了成熟的解决方案。
                </p>
                <a href="https://www.esign.cn/pcgw/jjfa/zzy/" class="get-info" target="_blank">了解详情</a>
                <div class="name demo">客户案例</div>
                <div class="demo-list">
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/huawei-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/hua-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/haikang-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/jiuyang-icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 10 -->
        <div :class="['every', 'item', actIndex === 9 ? 'active' : '']">
          <div class="content-box">
            <div class="left">
              <img src="@/assets/images/consumption-chain.png" alt="" />
            </div>
            <div class="right">
              <div class="righti">
                <h6 class="name">快消品电子签名解决方案</h6>
                <p class="content">
                  消费品市场需求量大、产品消耗快、需求重复、单品价格低、企业门槛低，行业竞争很是激烈，快消品产品的销售主要依靠线下门店和分销渠道，此外通过网络平台的销售。e签宝提供针对快消品供应链业务的电子签名应用帮助企业实现销售业务全过程的物流、资金流、信息流的有效管理和控制。
                </p>
                <a href="https://www.esign.cn/pcgw/jjfa/lskx/" class="get-info" target="_blank">了解详情</a>
                <div class="name demo">客户案例</div>
                <div class="demo-list">
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/hema-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/baiguoyuan-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/honging-icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 11 -->
        <div :class="['every', 'item', actIndex === 10 ? 'active' : '']">
          <div class="content-box">
            <div class="left">
              <img src="@/assets/images/logistics-chain.png" alt="" />
            </div>
            <div class="right">
              <div class="righti">
                <h6 class="name">物流行业电子签名解决方案</h6>
                <p class="content">
                  随着物流行业信息化的整体深化，无纸化已成为物流转型升级的关键点，如何在可信、高效、安全、环保的行业背景下，追求速度的飞跃是物流行业在转型期普遍面对的难题，而电子签名时代的到来则给传统的物流模式带来了新变化。
                </p>
                <a href="https://www.esign.cn/pcgw/jjfa/wlys/" class="get-info" target="_blank">了解详情</a>
                <div class="name demo">客户案例</div>
                <div class="demo-list">
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/debang-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/baishi-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/tiantu-icon.png" alt="" />
                  </div>
                  <div class="demo-item">
                    <img class="s-box" src="@/assets/images/transfer-icon.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 12 -->
        <!-- <div :class="['every', 'item', actIndex === 11 ? 'active' : '' ]">
					<div class="content-box">
						<div class="left">
							<img src="@/assets/images/internet-chain.png" alt="" />
						</div>
						<div class="right">
							<div class="righti">
								<h6 class="name">互联网金融电子签名和存证解决方案</h6>
								<p class="content">
									近年来互联网金融发展迅速，但也暴露了较多的风险问题，基于金融安全考虑，国家对互联网金融平台的监管越来越严格，其中对于电子签名和存证提出了明确要求，而e签宝针对国家法规要求提出了一整套针对互联网金融行业的专业解决方案。
								</p>
								<a href="javascript:;" class="get-info">了解详情</a>
								<div class="name demo">客户案例</div>
								<div class="demo-list">
									<div class="demo-item">
										<img class="s-box" src="@/assets/images/huaxia-icon.png" alt="" />
									</div>
									<div class="demo-item">
										<img class="s-box" src="@/assets/images/nanjing-icon.png" alt="" />
									</div>
									<div class="demo-item">
										<img class="s-box" src="@/assets/images/suzhou-icon.png" alt="" />
									</div>
									<div class="demo-item">
										<img class="s-box" src="@/assets/images/lianhe-icon.png" alt="" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
export default {
  props: {},
  data() {
    return {
      actIndex: 0,
      mySwiper: '',
      showPre: false,
      showNext: true,
    }
  },
  mounted() {
    const that = this
    this.mySwiper = new Swiper('.userSs', {
      speed: 800,
      // slidesPerView: 7,
      slidesPerGroup: 5,
      width: 188,
      navigation: {
        nextEl: '.userNext',
        prevEl: '.userPrev',
      },
      // direction: 'horizontal', // 垂直切换选项
      // loop: false, // 循环模式选项
      // pagination: { el: '.swiper-pagination' },
      // autoplay: false,
      // breakpoints: {
      // 	768: {
      // 		allowTouchMove: true,
      // 		slidesPerView: 3.5,
      // 		slidesPerGroup: 1,
      // 	},
      // },
      on: {
        // slideChange: function() {
        //   that.actIndex = this.activeIndex
        // },
        slideChangeTransitionStart() {
          console.log('this.realIndex', this.realIndex)
          if (this.realIndex >= 5) {
            that.showPre = true
            that.showNext = false
          } else {
            that.showPre = false
            that.showNext = true
          }
          // if (this.realIndex !== 0) {
          // 	that.showPre = true
          // } else {
          // 	that.showPre = false
          // }
          // console.log(this.realIndex)
          // if (this.realIndex == 4) {
          // 	that.showNext = false
          // } else {
          // 	that.showNext = true
          // }
        },
      },
    })
    // console.info(swiper)
  },
  methods: {
    // 选中tab
    selectBar(index) {
      if (this.actIndex !== index) {
        this.actIndex = index
        console.log('this.mySwiper', this.mySwiper)
        // this.mySwiper.slideTo(index, 1000, false)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.slide-active {
  position: relative;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 188px;
    height: 4px;
    background: #e61717;
  }
}
.home-banner {
  position: relative;
  width: 100%;
  height: 100vh;
}
.home-banner .home-head {
  height: 100px;
  background-color: red;
}
.home-banner .home-head .elogo,
.home-banner .home-head .nav-bar {
  float: left;
}
.home-banner #banner_video,
#banner_video {
  overflow: hidden;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  background: #000;
}
.home-banner #banner_video video,
.home-banner #banner_video img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home-banner #banner_video img {
  display: none;
}
@media only screen and (max-width: 768px) {
  .home-banner #banner_video video {
    display: none;
  }
  .home-banner #banner_video img {
    display: block;
  }
}
.home-banner .home-head .signin {
  float: right;
}
.text-info {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 0 5%;
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
}
.text-info .page-title p {
  font-size: 52px;
  color: #ffffff;
  line-height: 73px;
  display: inline-block;
  font-weight: 500;
  margin-bottom: 12px;
}
.text-info .page-title .empty_space {
  width: 35px;
  display: inline-block;
}
@media screen and (max-width: 768px) {
  .home-banner .text-info .page-title p {
    font-size: 30px;
    font-weight: 500;
    color: #ffffff;
    line-height: 42px;
    letter-spacing: 2px;
    margin-bottom: 8px;
  }
  .text-info .page-title .empty_space {
    width: 20px;
  }
}
.text-info .banner-btns a:hover {
  -webkit-transform: translateY(-8px);
  -ms-transform: translateY(-8px);
  transform: translateY(-8px);
  box-shadow: 0 4px 12px rgba(50, 10, 10, 0.2);
  background: #e61717;
  border-color: #e61717;
}
.home-banner {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 640px;
}
.home-banner .banner_pc_box {
  background: #000308;
  width: 100%;
  height: 100%;
}
.home-banner .banner {
  width: 100%;
  height: 100%;
}
.home-banner .banner.pc {
  margin: 0 auto;
  max-width: 1920px;
  background: no-repeat center / cover url('https://www.esign.cn/images/index_pc_banner.png');
}
.home-banner .banner.h5 {
  display: none;
  background: no-repeat center / cover url('https://www.esign.cn/images/index_h5_banner.png');
}
.home-banner .mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 0;
  top: 0;
}
@media screen and (max-width: 1280px) {
  .home-banner {
    height: 500px;
  }
}
@media screen and (max-width: 768px) {
  .home-banner .banner_pc_box {
    display: none;
  }
  .home-banner .banner.pc {
    display: none;
  }
  .home-banner .banner.h5 {
    display: block;
  }
}
.home-banner .text-info {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 0 5%;
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
}
.home-banner .text-info .page-msg {
  line-height: 25px;
  display: inline-block;
  margin-bottom: 37px;
  font-size: 18px;
}
@media screen and (max-width: 768px) {
  .home-banner .text-info .page-msg {
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    margin-bottom: 28px;
  }
}
.home-banner .text-info .banner-btns a {
  height: 44px;
  padding: 0 43px;
  line-height: 44px;
  color: #fff;
  border: 1px solid #fff;
  background: transparent;
  display: inline-block;
  transition: all 0.4s ease-in-out;
  box-shadow: 0px 2px 12px 0px rgba(156, 0, 0, 0.57);
  font-size: 18px;
  font-weight: 500;
}
@media screen and (max-width: 768px) {
  .home-banner .text-info .banner-btns a {
    min-width: 112px;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
  }
}
.home-banner .text-info .banner-btns a:hover {
  -webkit-transform: translateY(-8px);
  -ms-transform: translateY(-8px);
  transform: translateY(-8px);
  box-shadow: 0 4px 12px rgba(50, 10, 10, 0.2);
  background: #e61717;
  border-color: #e61717;
}
.home-banner .text-info .banner-btns a.free {
  background: #e61717;
  border-color: #e61717;
}
@keyframes updown {
  0% {
    bottom: 18px;
  }
  50% {
    bottom: 28px;
  }
  100% {
    bottom: 18px;
  }
}
@media screen and (max-width: 768px) {
  .home-banner {
    height: 96vw;
  }
  .home-banner .text-info .page-title .point {
    display: none;
  }
  .home-banner .text-info .banner-btns button {
    width: 20vw;
  }
}
.activity {
  position: relative;
  margin-top: -57px;
}
@media screen and (max-width: 1440px) {
  .activity {
    margin-top: -54px;
  }
}
.activity .activity_half {
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  left: 0;
  background: white;
}
.activity .activity_i {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
}
.activity .activity_i .item {
  width: 24%;
  background: #fff;
  position: relative;
  z-index: 1;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  height: 114px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.activity .activity_i .item:hover {
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);
}
.activity .activity_i .item .info {
  position: relative;
  text-align: left;
}
.activity .activity_i .item:hover .info .name .discription {
  color: #e61717;
  /* font-weight: 500; */
}
.activity .activity_i .item .img {
  width: 64px;
  height: 64px;
  margin: 0 4% 0 7%;
}
.activity .activity_i .item .info .name {
  position: relative;
  display: inline-block;
  font-size: 18px;
  color: #000000;
  line-height: 25px;
  margin-bottom: 4px;
  font-weight: 400;
  text-align: left;
}
.activity .activity_i .item .info .hot_box {
  position: absolute;
  right: -20px;
  top: -23px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.activity .activity_i .item .info .hot_box .hot {
  display: inline-block;
  background: #e61717;
  color: #fff;
  line-height: 16px;
  padding: 0 3px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
}
.activity .activity_i .item .info .hot_box .triangle {
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 5px solid #e61717;
  border-right: 7px solid transparent;
  border-left: 0px;
  border-bottom: 0px;
}
.activity .activity_i .item .info .msg {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  text-align: left;
}
@media screen and (max-width: 1440px) {
  .activity .activity_i .item {
    height: 108px;
  }
  .activity .activity_i .item .img {
    width: 52px;
    height: 52px;
    margin: 0 8px 0 20px;
  }
  .activity .activity_i .item .info .name {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 6px;
  }
  .activity .activity_i .item .info .msg {
    font-size: 13px;
    line-height: 18px;
  }
}
@media screen and (max-width: 768px) {
  .activity {
    display: none;
  }
  .home-banner .text-info .page-title .point {
    display: none;
  }
  .home-banner .text-info .banner-btns button {
    width: 20vw;
  }
}
.video-index {
  background: #fff;
  padding-top: 100px;
}
.video-index .video-index-i .video-info {
  width: 100%;
  margin-top: 90px;
  position: relative;
}
.video-index .video-index-i .video-info .play_outer {
  cursor: pointer;
  position: absolute;
  width: 32%;
  height: 57%;
  top: 5%;
  left: 0;
  right: 0;
  margin: auto;
}
.video-index .video-index-i .video-info .play_outer .play-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -40px;
  transition: all 0.4s ease-in-out;
  margin-left: -40px;
}
.video-index .video-index-i .video-info .play_outer:hover .play-icon {
  box-shadow: 0 12px 24px rgba(8, 30, 80, 0.1);
  transform: translateY(-10px);
}
.video-index .video-index-i .standard {
  display: flex;
  justify-content: space-between;
  margin-top: 19px;
  flex-wrap: wrap;
}
.video-index .video-index-i .standard .item {
  width: 25%;
  padding: 20px 0;
}
.video-index .video-index-i .standard .item .left {
  float: left;
  width: 25%;
  height: 40px;
  position: relative;
}
.video-index .video-index-i .standard .item .left img {
  width: auto;
  height: 38px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
  margin-top: -19px;
}
.video-index .video-index-i .standard .item .right {
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
}
.cell {
  text-align: center;
	.title {
		color: #000;
	}
	.des {
		color: #666B80;
	}
}
.cell h3,
.cell h1 {
  font-size: 40px;
  margin-bottom: 10px;
  font-weight: bold;
}
.cell h5 {
  font-size: 18px;
  font-weight: 400;
  color: #666b80;
}
.cell h5.white {
  color: #fff;
  padding: 0 20px;
}
@media screen and (max-width: 768px) {
  .cell h1,
  .cell h3 {
    font-size: 24px;
  }
  .cell h5 {
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  .video-index .video-index-i .video-info {
    margin-top: 30px;
  }
  .video-index {
    padding-top: 70px;
  }
  .video-index .video-index-i .video-info {
    margin-top: 30px;
  }
  .video-index .video-index-i .video-info .play_outer .play-icon {
    width: 50px;
    height: 50px;
    margin-top: -25px;
    margin-left: -25px;
  }
  .video-index .video-index-i .standard .item .left {
    width: 100%;
  }
  .video-index .video-index-i .standard .item .left img {
    height: 28px;
  }
  .video-index .video-index-i .standard .item .right {
    display: none;
  }
}
.contract-index {
  background: #fff;
  padding-top: 100px;
}
.contract-index .contract-index-i .contract-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 90px;
  background: #fafafc;
}
.contract-index .contract-index-i .contract-info .left {
  width: 29%;
}
.contract-index .contract-index-i .contract-info .left .right {
  align-items: flex-start;
}
.contract-index .contract-index-i .contract-info .left .item {
  position: relative;
  padding: 30px 20px;
  background: #fefefe;
  cursor: pointer;
  border-left: 1px solid #eee;
}
.contract-index .contract-index-i .contract-info .left .item:first-child {
  border-top: 1px solid #eee;
}
.contract-index .contract-index-i .contract-info .left .item:last-child {
  border-bottom: 1px solid #eee;
}
.contract-index .contract-index-i .contract-info .left .item.active {
  background: #fafafc;
  border-top-color: #fafafc;
  border-bottom-color: #fafafc;
}
.contract-index .contract-index-i .contract-info .left .item.active .name {
  color: #e61717;
}
.contract-index .contract-index-i .contract-info .left .item.active .line {
  transition: all 5s linear;
  width: 100%;
}
.contract-index .contract-index-i .contract-info .left .item:hover .name {
  color: #e61717;
}
.contract-index .contract-index-i .contract-info .left .item .right {
  overflow: hidden;
  text-align: left;
  background: transparent;
  flex-direction: column;
}
.contract-index .contract-index-i .contract-info .left .item .img {
  width: 70px;
  float: left;
  position: relative;
  top: -10px;
}
.contract-index .contract-index-i .contract-info .left .item .name {
  font-size: 20px;
  font-weight: 500;
  color: #202640;
  line-height: 28px;
  font-weight: 700;
  margin-bottom: 8px;
}
.contract-index .contract-index-i .contract-info .left .item .value {
  font-size: 14px;
  font-weight: 400;
  color: #202640;
  line-height: 22px;
}
.contract-index .contract-index-i .contract-info .left .item .line {
  width: 0%;
  height: 3px;
  background-color: #e61717;
  position: absolute;
  left: 0;
  bottom: 0;
}
.contract-index .contract-index-i .contract-info .right {
  width: 71%;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.contract-index .contract-index-i .contract-info .right .righti {
  position: relative;
  width: 90%;
}
.contract-index .contract-index-i .contract-info .right img {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
  opacity: 0;
  transition: all 0.4s ease-in-out;
  transform: scale(0.98) translateY(4%);
}
.contract-index .contract-index-i .contract-info .right img:first-child {
  position: relative;
}
.contract-index .contract-index-i .contract-info .right img.active {
  visibility: visible;
  opacity: 1;
  transform: scale(1) translateY(0px);
}
@media screen and (max-width: 768px) {
  .contract-index {
    max-width: 1400px;
    padding-top: 50px;
    margin: 0 auto;
  }
  .contract-index .contract-index-i .contract-info {
    margin-top: 20px;
    flex-direction: column;
  }
  .contract-index .contract-index-i .contract-info .left {
    width: 100%;
    min-height: inherit !important;
  }
  .contract-index .contract-index-i .contract-info .left .item {
    border-right: 1px solid #eee;
  }
  .contract-index .contract-index-i .contract-info .left .item .right {
    width: auto;
  }
  .contract-index .contract-index-i .contract-info .right {
    display: none;
  }
  .contract-index .contract-info {
    display: flex;
    justify-content: space-between;
  }
  .contract-index .contract-info .left {
    width: 100%;
  }
  .contract-index .contract-info .left .item.active {
    background: #fff;
  }
  .contract-index .contract-info .left .item.active .name {
    color: #202640;
  }
  .contract-index .contract-info .left .item.active .line {
    display: none;
  }
  .contract-index .contract-info .left .item:hover .name {
    color: #202640 !important;
  }
  .contract-index .contract-info .left .item .name {
    font-size: 20px;
    font-weight: 500;
    color: #202640;
    line-height: 28px;
    font-weight: 700;
    margin-bottom: 6px;
  }
  .contract-index .contract-info .left .item .value {
    font-size: 14px;
    font-weight: 400;
    color: #202640;
    line-height: 22px;
  }
  .contract-index .contract-info .left .item .line {
    width: 0%;
    height: 2px;
    background-color: #e61717;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .contract-index .contract-info .left .item .right {
    display: block;
  }
  .contract-index .contract-info .right {
    display: none;
  }
}
.prog_list {
  position: relative;
  padding-bottom: 60px;
}
.programme-index .item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  visibility: hidden;
  opacity: 0;
  transition: all 0.5s linear;
}
.programme-index .item:first-child {
  position: relative;
}
.programme-index .item .content-box .left {
  background-color: #fff;
  overflow: hidden;
}
.programme-index .item .content-box .left img {
  transform: scale(1.1);
  transition: all 0.5s linear;
}
.programme-index .item .content-box .right {
  // border: 1px solid #eee;
  border-left: 0;
}
.programme-index .item .content-box .right .righti {
  transition: all 0.5s linear;
  transform: translateY(50px);
}
.programme-index .item.active {
  opacity: 1;
  visibility: visible;
}
.programme-index .item.active .content-box .left img {
  transform: scale(1);
}
.programme-index .item.active .content-box .righti {
  transform: translateY(0px);
}
.programme-index {
  background: #fff;
  padding-top: 100px;
}
.programme-index .userSo {
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-top: 40px;
}
.programme-index .userSo .userSs .line {
  width: 14.28%;
  height: 3px;
  background: #e61717;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: all 0.4s ease-in-out;
}
.programme-index .userSo .userSs .swiper-slide {
  text-align: center;
  font-size: 0;
  padding: 30px 0;
  cursor: pointer;
  /*border-bottom: 3px solid transparent;*/
  transition: all 0.4s ease-in-out;
}
.programme-index .userSo .userSs .swiper-slide.active {
  /*border-bottom-color: #E61717;*/
}
.programme-index .userSo .userSs .swiper-slide .inner {
  display: inline-block;
}
.programme-index .userSo .userSs .swiper-slide .inner img {
  width: 70px;
  display: block;
  margin: auto;
}
.programme-index .userSo .userSs .swiper-slide .inner p {
  color: #000;
  font-size: 16px;
  text-align: center;
  transition: all 0.4s ease-in-out;
}
.programme-index .userSo .userSs .swiper-slide .inner:hover p {
  color: #e61717;
}
.programme-index .content-box {
  border: 1px solid #e5e5e5;
  min-height: 480px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.programme-index .content-box .left {
  width: 40%;
  background: #fafafc;
  display: flex;
  align-items: center;
  justify-content: center;
}
.programme-index .content-box .right {
  width: 60%;
  padding: 60px 40px;
}
.programme-index .content-box .right .name {
  font-size: 20px;
  color: #202640;
  line-height: 28px;
  margin-bottom: 22px;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.programme-index .content-box .right .name.demo {
  margin-top: 60px;
}
.programme-index .content-box .right .content {
  color: #202640;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 22px;
}
.programme-index .content-box .right .get-info {
  font-size: 16px;
  color: #e61717;
  padding-right: 22px;
  background: url('../../../../assets/images/get-info-jiantou.png') no-repeat right center;
  background-size: 17px auto;
  line-height: 22px;
  margin-bottom: 57px;
}
.programme-index .content-box .right .get-info:hover {
  opacity: 0.7;
}
.programme-index .content-box .right .demo-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.programme-index .content-box .right .demo-list .demo-item {
  flex: 1;
  display: inline-block;
}
.programme-index .content-box .right .demo-list .demo-item img {
  width: 90%;
  display: block;
  border: 1px solid #f0f0f0;
}
.programme-index .userPrevo,
.programme-index .userNexto {
  position: absolute;
  top: 50%;
  left: 0;
  width: 14.28%;
  height: 0px;
  padding-top: 14.28%;
  background: #fff;
  z-index: 9;
  transform: translateY(-50%);
  // visibility: hidden;
  // opacity: 0;
  transition: all 0.4s ease-in-out;
}
.programme-index .userNexto {
  right: 0;
  left: auto;
}
.programme-index .userPrevo.show,
.programme-index .userNexto.show {
  opacity: 1;
  visibility: visible;
}
.programme-index .userBtn {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 9;
  outline: none;
  transition: all 0.4s ease-in-out;
}
.programme-index .userBtn:hover {
  box-shadow: 0px 4px 8px 0px rgba(8, 30, 80, 0.1);
}
.programme-index .userBtn.userPrev {
  left: 0;
}
.programme-index .userBtn.userPrev img {
  transform: rotateZ(180deg);
}
@media screen and (max-width: 768px) {
  .programme-index {
    padding-top: 70px;
  }
  .programme-index .userPrevo,
  .programme-index .userNexto {
    display: none;
  }
  .programme-index .item .content-box {
    min-height: inherit;
    flex-direction: column;
  }
  .programme-index .item .content-box .left {
    width: 100%;
    min-height: inherit !important;
  }
  .programme-index .item .content-box .right {
    width: 100%;
    min-height: inherit !important;
    border-left: 1px solid #eee;
    border-top: 0;
  }
  .programme-index .item .content-box .right .name {
    font-size: 5vw;
    color: #202640;
    line-height: 7vw;
    margin-bottom: 3vw;
    font-weight: 700;
  }
  .programme-index .item .content-box .right .name.demo {
    display: none;
  }
  .programme-index .item .content-box .right .content {
    color: #202640;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 16px;
  }
  .programme-index .item .content-box .right .get-info {
    font-size: 4vw;
    color: #e61717;
    padding-right: 5vw;
    // background: url('../images/get-info-jiantou.png') no-repeat right center;
    background-size: 17px auto;
    line-height: 5vw;
    margin-bottom: 13vw;
  }
  .programme-index .item .content-box .right .get-info:hover {
    opacity: 0.7;
  }
  .programme-index .item .content-box .right .demo-list {
    display: none;
  }
  .programme-index .item .content-box .right .demo-list img {
    width: 90%;
    margin: 0 auto;
  }
  .programme-index .userSo {
    margin-top: 0;
  }
  .programme-index .userSo .userSs .line {
    width: 33.33%;
  }
  .programme-index .userSo .userSs .swiper-slide {
    text-align: center;
    font-size: 0;
    padding: 30px 0;
    cursor: pointer;
    /*border-bottom: 3px solid transparent;*/
    transition: all 0.4s ease-in-out;
  }
  .programme-index .userSo .userSs .swiper-slide.active {
    /*border-bottom-color: #E61717;*/
  }
  .programme-index .userSo .userSs .swiper-slide .inner {
    display: inline-block;
  }
  .programme-index .userSo .userSs .swiper-slide .inner img {
    width: 70px;
    display: none;
    margin: auto;
  }
  .programme-index .userSo .userSs .swiper-slide .inner p {
    color: #000;
    font-size: 16px;
    text-align: center;
    transition: all 0.4s ease-in-out;
  }
  .programme-index .userSo .userSs .swiper-slide .inner:hover p {
    color: #e61717;
  }
}
.users-index {
  overflow: hidden;
  background: #fff;
  padding-top: 100px;
}
.users-index .title {
  font-size: 40px;
  font-weight: 700;
  text-align: center;
}
.users-index .userSo {
  position: relative;
}
.users-index .userSo .peoSwipers {
  width: 660px;
}
.users-index .userSo .peoSwipers .swiper-slide {
  height: 180px;
  /*height: 240px;*/
  display: flex;
  align-items: center;
}
.users-index .userSo .peoSwipers .swiper-slide .inner {
  width: 100px;
  margin: 0 auto;
  position: relative;
  border-radius: 0 0 50px 50px;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.2s ease-in-out, width 0.4s ease-in-out, border-radius 0.4s ease-in-out;
}
.users-index .userSo .peoSwipers .swiper-slide .inner img {
  position: relative;
  z-index: 3;
  width: 100%;
  transform: translateY(0px);
  transition: all 0.4s ease-in-out;
}
.users-index .userSo .peoSwipers .swiper-slide .inner::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  padding-top: 100%;
  background: #dddee2;
  border-radius: 50%;
  transition: all 0.4s ease-in-out;
}
.users-index .userSo .peoSwipers .swiper-slide.swiper-slide-prev .inner,
.users-index .userSo .peoSwipers .swiper-slide.swiper-slide-next .inner {
  opacity: 1;
}
.users-index .userSo .peoSwipers .swiper-slide.swiper-slide-active .inner {
  opacity: 1;
  width: 180px;
  border-radius: 0 0 90px 90px;
}
.users-index .userSo .peoSwipers .swiper-slide.swiper-slide-active .inner img {
  transform: translateY(0);
}
.users-index .userBtn {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 9;
  outline: none;
  /*opacity: 0;*/
  transition: all 0.4s ease-in-out;
}
.users-index .userBtn:hover {
  box-shadow: 0px 4px 8px 0px rgba(8, 30, 80, 0.1);
}
.users-index .userBtn.userPrev1 {
  left: 0;
}
.users-index .userBtn.userPrev1 img {
  transform: rotateZ(180deg);
}
.users-index .userBtn.userNext1 {
  right: 0;
}
.users-index .more {
  color: #e61717;
  text-align: center;
  height: 40px;
  line-height: 40px;
  margin-top: 20px;
  margin-bottom: 72px;
  cursor: pointer;
}
.users-index .more img {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  vertical-align: middle;
  margin-left: 20px;
}
.users-index .head-box {
  position: relative;
  height: 280px;
}
.users-index .head-box .item {
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 180px;
  margin-left: -90px;
}
.users-index .head-box .left {
  width: 100px;
  bottom: 40px;
  margin-left: -280px;
}
.users-index .head-box .right {
  width: 100px;
  bottom: 40px;
  margin-left: 180px;
}
.users-index .head-box .btn {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  bottom: 61px;
  right: 2%;
}
.users-index .head-box .btn img {
  border-radius: 50%;
}
.users-index .head-box .btn.btn-left {
  left: 2%;
  transform: rotate(180deg);
}
.users-index .item img {
  width: auto;
  height: 100%;
  margin: 0 auto;
  border-radius: 50%;
}
.users-index .user-info {
  width: 65%;
  margin: 0 auto;
  text-align: center;
}
.users-index .user-info .name {
  font-size: 24px;
  font-weight: 600;
  color: #202640;
  line-height: 33px;
  margin-top: 26px;
  margin-bottom: 17px;
}
.users-index .user-info .work {
  font-size: 16px;
  font-weight: 400;
  color: #666b80;
  line-height: 22px;
  margin-bottom: 24px;
}
.users-index .user-info .user-say {
  font-size: 18px;
  font-weight: 400;
  color: #202640;
  line-height: 40px;
}
@media screen and (max-width: 768px) {
  .users-index {
    padding-top: 70px;
  }
  .users-index .title {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
  }
  .users-index .more {
    color: #e61717;
    text-align: center;
    height: 8vw;
    line-height: 8vw;
    margin-top: 4vw;
    margin-bottom: 30px;
  }
  .users-index .more img {
    display: inline-block;
    width: 4vw;
    height: 4vw;
    border-radius: 50%;
    vertical-align: middle;
    margin-left: 4vw;
  }
  .users-index .userSo .peoSwipers {
    width: 100%;
  }
  .users-index .userSo .peoSwipers .swiper-slide {
    height: 100px;
    display: flex;
    align-items: center;
  }
  .users-index .userSo .peoSwipers .swiper-slide .inner {
    width: 100px;
  }
  .users-index .head-box {
    position: relative;
    height: 280px;
  }
  .users-index .head-box .item {
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 33vw;
    margin-left: -90px;
  }
  .users-index .head-box .left {
    width: 18vw;
    bottom: 40px;
    margin-left: -37vw;
  }
  .users-index .head-box .right {
    width: 18vw;
    bottom: 40px;
    margin-left: 19vw;
  }
  .users-index .head-box .btn {
    display: none;
  }
  .users-index .user-info {
    width: auto;
    margin: 0 auto;
    text-align: center;
    padding: 0 15px;
  }
  .users-index .user-info .name {
    font-size: 20px;
    font-weight: bold;
    color: #202640;
    line-height: 32px;
    margin-top: 5vw;
    margin-bottom: 4vw;
  }
  .users-index .user-info .work {
    font-size: 12px;
    color: #666b80;
    line-height: 24px;
    margin-bottom: 16px;
  }
  .users-index .user-info .user-say {
    font-size: 14px;
    color: #202640;
    line-height: 22px;
  }
  .users-index .userSo .peoSwipers .swiper-slide .inner {
    width: 60px;
  }
  .users-index .userSo .peoSwipers .swiper-slide.swiper-slide-active .inner {
    width: 100px;
  }
  .userBtn {
    display: none;
  }
}
.customer-index {
  background: #fff;
  padding: 70px 0 100px;
  text-align: center;
}
.customer-index .btnsspans {
  margin: 0 15px;
  display: inline-block;
  width: 64px;
  line-height: 60px;
  cursor: pointer;
}
.btnsspans:hover {
  color: red;
}
.btnsclick {
  border-bottom: 1px solid red;
}
.btnsspan:hover {
  color: red;
}
.btnsspanss {
  border-bottom: 3px solid red;
}
.customer-index .btnsspan {
  margin: 0 15px;
  display: inline-block;
  width: 64px;
  line-height: 60px;
  cursor: pointer;
}
#rlbtns {
  border-bottom: 1px solid #e4e7ed;
}
.btn-head {
  position: relative;
}
.btn-head span {
  position: absolute;
  top: 20px;
  display: none;
  cursor: pointer;
}
#spanone {
  right: 0;
}
#spantwo {
  left: 0;
}
@media screen and (max-width: 930px) {
  .btn-head span {
    display: block;
  }
}
.customer-index .more {
  display: inline-block;
  font-size: 16px;
  font-weight: 400;
  color: #e61717;
  line-height: 22px;
  padding-right: 22px;
  // background: url('../images/get-info-jiantou.png') no-repeat right center;
  background-size: 17px;
  margin-top: 40px;
}
.customer-index .more a {
  color: inherit;
}
@media screen and (max-width: 768px) {
  .customer-index {
    margin-top: 0;
    text-align: center;
    padding-bottom: 70px;
  }
  .customer-index .more {
    display: inline-block;
    font-size: 3.5vw;
    font-weight: 400;
    color: #e61717;
    line-height: 22px;
    padding-right: 22px;
    // background: url('../images/get-info-jiantou.png') no-repeat right center;
    background-size: 17px;
    margin-top: 40px;
  }
}
.sign-index {
  text-align: center;
  color: #fff;
  overflow: hidden;
}
.sign-index .mask {
  background-color: rgba(24, 31, 60, 0.6);
  padding-bottom: 30px;
  position: relative;
  /* background: no-repeat center / cover
    url('https://www.esign.cn/images/index_pc_banner.png'); */
}
@media screen and (max-width: 768px) {
  .sign-index .mask {
    /* background: no-repeat center / cover
      url('https://www.esign.cn/images/index_h5_banner.png'); */
  }
}
.iconfont {
  font-size: 40px !important;
}
.sign-index .name {
  font-size: 50px;
  font-weight: 500;
  color: #ffffff;
  line-height: 70px;
  padding-top: 60px;
  margin-bottom: 30px;
}
.sign-index .count a {
  font-size: 16px;
  color: #fff;
  transition: all 0.4s ease-in-out;
  position: relative;
  display: inline-block;
}
.sign-index .count a::after {
  content: '';
  display: block;
  background: #fff;
  width: 100%;
  margin-top: 4px;
  height: 1px;
  transition: all 0.4s ease-in-out;
}
.sign-index .count a:hover {
  color: #e61717;
}
.sign-index .count a:hover::after {
  background: #e61717;
}
.sign-index .count a .qr-img {
  width: 140px;
  margin-left: -70px;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transition: all 0.4s ease-in-out;
  background: #fff;
}
.sign-index .count a .qr-img p {
  color: #333;
  font-size: 16px;
  padding-bottom: 10px;
  text-align: center;
}
.sign-index .count a .qr-img::before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  bottom: -8px;
  border: 7px solid transparent;
  border-bottom: 0;
  border-top: 8px solid #fff;
  left: 0;
  right: 0;
  margin: auto;
}
.sign-index .count a .qr-img.isShow {
  opacity: 1;
  visibility: visible;
}
.sign-index .btn_group {
  font-size: 0;
}
.sign-index .btn_group a {
  width: 120px;
  line-height: 38px;
  height: 40px;
  color: #fff;
  border: 1px solid #fff;
  background: transparent;
  display: inline-block;
  transition: all 0.4s ease-in-out;
  font-size: 16px;
}
.sign-index .btn_group a.register {
  background: #e61717;
  border-color: #e61717;
}
.sign-index .btn_group a:hover {
  -webkit-transform: translateY(-4px);
  -ms-transform: translateY(-4px);
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(50, 10, 10, 0.2);
  background: #e61717;
  border-color: #e61717;
}
.sign-index .num-box {
  display: flex;
  padding-top: 80px;
  padding-bottom: 65px;
}
.sign-index .num-box .item {
  width: 33.33%;
  text-align: center;
  font-size: 0;
}
.sign-index .num-box .item .itemi {
  display: inline-block;
  text-align: left;
}
.sign-index .num-box .item .num {
  font-size: 26px;
  font-weight: 400;
  color: #ffffff;
  line-height: 37px;
  margin-bottom: 4px;
}
.sign-index .num-box .item .num strong {
  font-size: 3.2vw;
  color: #ffffff;
  line-height: 69px;
}
.sign-index .num-box .item .msg {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  line-height: 26px;
  text-align: center;
}
.qr-model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  transition: all 0.4s ease-in-out;
}
.qr-model .mask {
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
}
.qr-model .inner {
  width: 295px;
  height: 390px;
  position: absolute;
  z-index: 9;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.qr-model .inner p {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #666;
  font-size: 14px;
}
.qr-model.isShow {
  opacity: 1;
  visibility: visible;
}
@media screen and (min-width: 1920px) {
  .sign-index .num-box .item .num strong {
    font-size: 60px;
  }
}
@media screen and (max-width: 768px) {
  .sign-index {
    background-size: auto 100%;
  }
  .sign-index .mask {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .sign-index .name {
    font-size: 24px;
    line-height: 28px;
    padding: 0;
  }
  .sign-index .btn_group a.register {
    display: none;
  }
  .sign-index .num-box {
    display: block;
    text-align: left;
    padding: 30px 0;
  }
  .sign-index .num-box .item {
    width: 100%;
    margin-top: 8vw;
  }
  .sign-index .num-box .item .itemi {
    display: block;
    text-align: center;
    padding: 0 5%;
  }
  .sign-index .num-box .item:first-child {
    margin-top: 0;
  }
  .sign-index .num-box .item .num {
    font-size: 26px;
    font-weight: 400;
    color: #ffffff;
    line-height: 37px;
    margin-bottom: 4px;
  }
  .sign-index .num-box .item .num strong {
    font-size: 11vw;
    color: #ffffff;
    line-height: 12vw;
  }
  .sign-index .num-box .item .msg {
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    line-height: 4.5vw;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
/* 鐏嫄 */
input {
  -moz-appearance: textfield;
}
.bear {
  position: fixed;
  right: 100%;
  bottom: 0;
  width: 100%;
  height: 140px;
  background-color: #000;
  z-index: 999;
  background-clip: content-box;
  transition: all 0.4s ease-in-out;
  transform: translateX(-100%);
}
.bear.active {
  right: 0%;
}
.bear.active .small {
  display: none;
}
.bear.active2 {
  transform: translateX(0%);
}
.bear .small {
  width: 100px;
  position: absolute;
  left: 100%;
  bottom: 6px;
  cursor: pointer;
  display: block;
}
.bear .content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.bear .content .big_elephant {
  display: flex;
}
.bear .content .bear_close {
  cursor: pointer;
  width: 26px;
  height: 26px;
  transition: all 0.4s ease-in-out;
}
.bear .content .bear_close:hover {
  transform: rotateZ(90deg);
}
.bear .content .big-img {
  width: 187px;
  height: 91px;
}
.bear .content .item {
  flex: 1;
  position: relative;
  z-index: 100;
  margin-right: 12px;
}
.bear .content .item .get-code {
  width: 45%;
  height: 100%;
  line-height: 40px;
  font-size: 14px;
  color: #e61717;
  background-color: #e8e8ed;
  text-align: center;
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 3px 3px 0;
}
.bear .content .item .get-code.active {
  opacity: 0.5;
}
.bear .content .item .tip {
  font-size: 12px;
  height: 0;
  color: #e61717;
}
.bear .content .item input {
  width: 100%;
  font: 400 14px Arial;
  display: block;
  height: 48px;
  padding-left: 15px;
  border-radius: 3px;
  outline: none;
  border: none;
  overflow: hidden;
  border: 1px solid transparent;
}
.bear .content .item input.active {
  color: #e61717;
  border-color: #e61717;
}
.bear .content .item input.active::-webkit-input-placeholder {
  color: #e61717;
}
.bear .content .item input.active::-moz-placeholder {
  color: #e61717;
}
.bear .content .item input.active:-moz-placeholder {
  color: #e61717;
}
.bear .content .item input.active:-ms-input-placeholder {
  color: #e61717;
}
.bear .content .item input.active2 {
  color: #e61717;
}
.bear .content .item input.active2::-webkit-input-placeholder {
  color: #e61717;
}
.bear .content .item input.active2::-moz-placeholder {
  color: #e61717;
}
.bear .content .item input.active2:-moz-placeholder {
  color: #e61717;
}
.bear .content .item input.active2:-ms-input-placeholder {
  color: #e61717;
}
.bear .content .item .try_btn {
  width: 45%;
  height: 48px;
  border-radius: 3px;
  float: left;
}
.bear .content .item button {
  width: 240px;
  display: block;
  height: 40px;
  background-color: #e61717;
  color: #fff;
  font-size: 16px;
}
.bear .content .try_item {
  flex: 2;
}
#man-machine-slide {
  width: 50%;
  float: left;
  margin-right: 12px;
}
@media only screen and (max-width: 768px) {
  .bear {
    display: none;
  }
}
.tabsul li {
  cursor: pointer;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 20px;
  font-size: 14px;
}
.tabsul li span div {
  padding-left: 10px;
}
.userSo .swiper-wrapper {
  height: auto;
}

.userTextS .swiper-wrapper {
  height: auto;
}
#nc_1_wrapper,
#nc_2_wrapper,
#nc_3_wrapper {
  width: 100% !important;
  height: 48px !important;
  line-height: 48px !important;
}
.nc_scale {
  height: 48px !important;
}
.nc-container .nc_scale span {
  height: 48px !important;
  line-height: 48px !important;
}
.nc-container .nc_scale span {
  line-height: 48px !important;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro SC', 'SF Pro Text', 'Helvetica Neue', Helvetica, 'PingFang SC', 'Segoe UI', Roboto,
    'Hiragino Sans GB', arial, 'microsoft yahei ui', 'Microsoft YaHei', SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro SC', 'SF Pro Text', 'Helvetica Neue', Helvetica, 'PingFang SC', 'Segoe UI', Roboto,
    'Hiragino Sans GB', arial, 'microsoft yahei ui', 'Microsoft YaHei', SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
}
html.oh {
  overflow: hidden;
}
body {
  background: #fff;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
img {
  display: block;
  width: 100%;
  height: auto;
  border: none;
}
button {
  background-color: transparent;
  color: #fff;
  border: 0;
  cursor: pointer;
  outline: unset;
}
input {
  outline: none;
}
li {
  list-style: none;
}
a {
  color: #000;
  text-decoration: none;
}
.hand {
  cursor: pointer;
}
.clear {
  zoom: 1;
}
.clear:after {
  clear: both;
  content: '.';
  display: block;
  width: 0;
  height: 0;
  visibility: hidden;
}
.line1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.line2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 48px;
  line-height: 24px;
}
.line3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 72px;
  line-height: 24px;
}
.s-box {
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.s-box:hover {
  box-shadow: 0 12px 24px rgba(8, 30, 80, 0.1);
  transform: translateY(-10px);
}
/* scrollbar */
/*::-webkit-scrollbar {
    width: 0px;
  }*/
/* scrollbar */
.tab-box {
  border-bottom: 1px solid #eee;
  padding: 0 80px;
}
/*.tab-box ::-webkit-scrollbar {
    height: 3px
  }
  ::-webkit-scrollbar-track-piece {
    width: 10px;
    background-color: #eee;
  }
  .tab-box ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    -webkit-transition: all 0.4s ease-in-out;
    -moz-transition: all 0.4s ease-in-out;
    -o-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
  }
  
  .tab-box ::-webkit-scrollbar-thumb:hover {
    background: #666;
  }*/
.tab-box .tab {
  max-width: 1180px;
  margin: 0 auto;
  font-size: 16px;
  position: relative;
  overflow: auto;
  white-space: nowrap;
  text-align: center;
}
.tab-box .tab button {
  color: #202640;
  line-height: 48px;
  padding: 0 25px;
  font-size: 16px;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -ms-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}
.tab-box .tab button:hover {
  color: #e61717;
}
.hoverLine-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 8px;
  z-index: -1;
}
.hoverLine-wrap .hoverLine {
  position: absolute;
  bottom: 0;
  left: 185px;
  width: 80px;
  height: 2px;
  background-color: #e61717;
  opacity: 0;
  transition: left 0.3s linear, width 0.3s linear;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.banxin,
.container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
}
@media (max-width: 1440px) {
  .banxin,
  .container {
    padding: 0 40px;
  }
}
@media (max-width: 1024px) {
  .banxin,
  .container {
    padding-left: 5%;
    padding-right: 5%;
  }
}
.animated {
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
  -webkit-animation-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
}
.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.animated.hinge {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}
.animated.bounceIn,
.animated.bounceOut {
  -webkit-animation-duration: 0.75s;
  animation-duration: 0.75s;
}
.animated.flipOutX,
.animated.flipOutY {
  -webkit-animation-duration: 0.75s;
  animation-duration: 0.75s;
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}
@-webkit-keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-50px, 0, 0);
    transform: translate3d(-50px, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInLeft {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-50px, 0, 0);
    transform: translate3d(-50px, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
.fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}
@-webkit-keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100px, 0, 0);
    transform: translate3d(100px, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(50px, 0, 0);
    transform: translate3d(50px, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
.fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}
@-webkit-keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 50px, 0);
    transform: translate3d(0, 50px, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 50px, 0);
    transform: translate3d(0, 50px, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}
.nuxt-progress {
  display: none !important;
}
.video_model {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video_model .mask {
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
}
.video_model .inner {
  position: relative;
  z-index: 9;
  max-width: 1000px;
  width: 100%;
}
.video_model .inner video {
  display: block;
  width: 100%;
}
.video_model .inner .el-icon-close {
  font-size: 24px;
  color: #fff;
  position: absolute;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  padding: 4px;
  top: 6px;
  right: 6px;
  z-index: 10;
}
.video_models {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video_models .mask {
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
}
.video_models .inner {
  position: relative;
  z-index: 9;
  max-width: 1000px;
  width: 100%;
}
.video_models .inner video {
  display: block;
  width: 100%;
}
.video_models .inner .el-icon-close {
  font-size: 24px;
  color: #fff;
  position: absolute;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  padding: 4px;
  top: 6px;
  right: 6px;
  z-index: 10;
}
@media (max-width: 1024px) {
  .tab-box {
    padding: 0 5%;
  }
}
@media (max-width: 768px) {
  .solve-nav {
    display: none;
  }
  .banner .btn_g {
    display: none !important;
  }
  .video_model .inner .el-icon-close {
    top: -40px;
  }
}
.news-detail img {
  max-width: 100%;
  height: auto !important;
}
.table-bordered {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  border: 1px solid #ddd;
}
.table-bordered > tbody > tr > td,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > td,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
  border: 1px solid #ddd;
}
.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
  border-bottom-width: 2px;
}
.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}
.table-hover > tbody > tr:hover {
  background-color: #f5f5f5;
}
.table-bordered > tbody > tr > td,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > td,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > thead > tr > th {
  padding: 8px;
}
.footer-dialog {
  width: 100%;
}
.footer-dialog .el-dialog {
  margin: 80px auto;
  max-width: 700px;
}
.footer-dialog .el-dialog__body {
  overflow: auto;
}
/* 鐢变簬澧炲姞seo浼樺寲浠ｇ爜涔嬪悗锛屼細鐢熸垚涓€涓猤if锛屽鏋滀笉璁剧疆锛屼細榛樿100% http://jira.timevale.cn:8081/browse/HELIOS-179 */
#cnzz_stat_icon_1279012337 img {
  display: none;
}
</style>
